import DownloadApp from "../components/DownloadApp";
import UseCaseHospitalitySection from "../components/PageSections/UseCases/UseCaseHospitalitySection";


const UseCaseHospitalityPage = () => {
    return (
        <main>
            <UseCaseHospitalitySection />
            <DownloadApp />
        </main>
    );
};

export default UseCaseHospitalityPage;
